export default __webpack_public_path__ + "static/media/Group 1278.d4562c1e.png";